import React from "react"
export function UploadFill(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 2a8 8 0 110 16 8 8 0 010-16zm3.333 11.067H6.712v1.6h6.621v-1.6zm-2.829-7.551a.85.85 0 00-1.02-.025l-.095.08-2.722 2.667 1.178 1.124 1.305-1.28v3.403h1.656l-.001-3.403 1.305 1.28 1.179-1.124-2.722-2.667-.063-.055z"
        fill="currentColor"
        id="prefix__upload---fill"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
